import React from 'react';

const UniqueTemplate = () => {
  return (
    <section className="sub_container pt-0">
      <ul className="hd_info">
        <li>
          <span>공고일</span>
          2024.08.20
        </li>
        <li>
          <span>개정사항</span>
          약관내용수정
        </li>
        <li>
          <span>시행일</span>
          2024.08.20
        </li>
      </ul>
      <div className="Padding-20 text">
        개인정보보호법 제15조 제1항 제3호에 따라 정보주체의 동의없이 개인정보를 처리합니다.
        <br />
        <br />
        수집하는 개인정보 항목 : 주민등록번호
        <br />
        개인정보 처리 사유 : ‘내가 먹는 약! 한눈에’(개인투약이력조회) 서비스 제공을 위한 본인확인
        <br />
        처리근거 : 국민건강보험법 제63조 및 동법 시행령 제81조(의료급여법 시행령 제21조)
        <br />
      </div>
    </section>
  );
};

export default UniqueTemplate;
